import CustomButton from "@/components/CustomButton";
import { IS_PRODUCTION } from "@/constants/constants";
import { getHouseholdPrintFileName } from "@/helper/helper";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useUPPrint } from "@/hooks/useUPPrint";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

type Props = {
  hasUPData: boolean;
  externalCode: string;
};

export default function PrintUPButton({ hasUPData, externalCode }: Props) {
  const { mutateAsync: downloadAsync, error: printErrorMsg, isPending } = useUPPrint();
  const { isModified, showRoR, showSocialSecurity, showHiddenRows } = useAppSelector(
    (state) => state.uq
  );
  const {
    household,
    header: { isError },
  } = useAppSelector((state) => state.household);

  const fileName = getHouseholdPrintFileName({
    clientCode: household?.clientCode,
    tabName: "Unique Possibilities",
  });

  const toastMessages = {
    pending: "Downloading Unique Possibilities..",
    success: "Unique Possibilities downloaded!",
    error:
      printErrorMsg instanceof AxiosError
        ? printErrorMsg.message
        : "Downloading Unique Possibilities failed",
  };

  if (IS_PRODUCTION || isError) return null;

  return (
    <div>
      <CustomButton
        className="print:hidden"
        text={"Print to PDF"}
        disabled={!hasUPData || isModified || isPending}
        onClickHandler={() => {
          toast.promise(
            downloadAsync({
              clientCode: household?.clientCode,
              externalCode,
              fileName,
              showRoR: showRoR,
              showSS: showSocialSecurity,
              showHiddenRows,
            }),
            toastMessages
          );
        }}
      />
    </div>
  );
}
